function lightbox(trigger) {
    var getItem = function (image) {
        var galleryLink = image.matches('a.mss-photo-gallery-image') ? image : image.closest('a.mss-photo-gallery-image');
        if (galleryLink) {
            var thumb = galleryLink.querySelector('img');
            return {
                src: galleryLink.href,
                msrc: thumb ? (thumb.currentSrc || thumb.src) : galleryLink.href,
                w: Number(galleryLink.dataset.width) || (thumb && thumb.naturalWidth) || 0,
                h: Number(galleryLink.dataset.height) || (thumb && thumb.naturalHeight) || 0,
                el: thumb || galleryLink,
            };
        }

        var width = image.getAttribute('width');
        var height = image.getAttribute('height');
        var src = width && height ? image.getAttribute('src') : (image.currentSrc || image.getAttribute('src'));
        return {src: src, msrc: src, w: width || image.naturalWidth, h: height || image.naturalHeight, el: image};
    };

    var openGallery = function (pswpElement, items, index) {
        var options = {
            bgOpacity: 0.9,
            closeOnScroll: true,
            fullscreenEl: false,
            history: false,
            index: index,
            shareEl: false,
            zoomEl: false,
            getThumbBoundsFn: function (i) {
                var thumbnail = items[i].el;
                if (!thumbnail || !thumbnail.getBoundingClientRect) return false;
                var rect = thumbnail.getBoundingClientRect();
                if (!rect.width || !rect.height) return false;
                var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            }
        };

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.listen('gettingData', function (i, item) {
            if (item.w > 0 && item.h > 0) return;
            var image = new Image();
            image.onload = function () {
                item.w = this.naturalWidth;
                item.h = this.naturalHeight;
                gallery.invalidateCurrItems();
                gallery.updateSize(true);
            };
            image.src = item.src;
        });
        gallery.init();
        return false;
    };

    var onThumbnailsClick = function (e) {
        var photoLink = e.target.closest('a.mss-photo-gallery-image');
        if (photoLink) {
            e.preventDefault();
            var pswp = document.querySelector('.pswp');
            var section = photoLink.closest('[data-mss-gallery]');
            if (!pswp || !section) return false;
            var links = Array.from(section.querySelectorAll('a.mss-photo-gallery-image'));
            var items = links.map(getItem);
            return openGallery(pswp, items, Math.max(0, links.indexOf(photoLink)));
        }

        e.preventDefault();
        var pswpElement = document.querySelector('.pswp');
        if (!pswpElement) return false;
        var items = [];
        var index = 0;
        var card = e.target.closest('.kg-card');

        if (card) {
            var prevSibling = card.previousElementSibling;
            while (prevSibling && (prevSibling.classList.contains('kg-image-card') || prevSibling.classList.contains('kg-gallery-card'))) {
                var prevItems = [];
                prevSibling.querySelectorAll('img').forEach(function (item) { prevItems.push(getItem(item)); index += 1; });
                prevSibling = prevSibling.previousElementSibling;
                items = prevItems.concat(items);
            }
        }

        if (!card || e.target.classList.contains('kg-image')) {
            items.push(getItem(e.target));
        } else {
            var reachedCurrentItem = false;
            var currentCard = e.target.closest('.kg-gallery-card');
            if (currentCard) currentCard.querySelectorAll('img').forEach(function (item) {
                items.push(getItem(item));
                if (!reachedCurrentItem && item !== e.target) index += 1;
                else reachedCurrentItem = true;
            });
        }

        if (card) {
            var nextSibling = card.nextElementSibling;
            while (nextSibling && (nextSibling.classList.contains('kg-image-card') || nextSibling.classList.contains('kg-gallery-card'))) {
                nextSibling.querySelectorAll('img').forEach(function (item) { items.push(getItem(item)); });
                nextSibling = nextSibling.nextElementSibling;
            }
        }
        return openGallery(pswpElement, items, index);
    };

    document.addEventListener('click', function (e) {
        var target = e.target.closest(trigger);
        if (target) onThumbnailsClick(e);
    });
}
